import styled from 'styled-components';

const Wrapper = styled.div`
    vertical-align: middle;
    margin-left: 9px;
    height: 22px;
`;

export default Wrapper;
